module.exports = __webpack_public_path__ + "img/reglamentoinfantilpoomses.14abb65d.png";